// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyLayoutWithLogout_wrapper__I8uQ4"};